module.exports = __webpack_public_path__ + "static/1hr-2a924a67da53ff0591fa702cb41c6e82.svg";